export class OperatingSystem {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "kernel",
            "baseName": "kernel",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OperatingSystem.attributeTypeMap;
    }
    constructor() {
    }
}
